import React from "react";
import './simulation.css';

import { Typography } from 'antd';
const { Title } = Typography;

const titleStyle = {
  color: "white",
  margin:"80px"
}

function Simulation() {
  return (
    <div>
              <Title level={1} style={titleStyle}>Simulation Loading..</Title>        
      <iframe
        className="unity-canvas"
        src="unity/index.html"
        name="webgl"
        height="100%"
        width="100%"
        sandbox="allow-downloads allow-scripts allow-same-origin allow-forms allow-popups"
      />
    </div>
  );
}

export default Simulation;
